<template>
  <TreeInput
    v-model="value"
    :is-multi="multiple"
    :options="options"
    :label="label"
    :hide-label="hideLabel"
    :placeholder="placeholder"
    :disabled="disabled"
    :model-type="modelType"
    :async="async"
    :disable-branch-nodes="disableBranchNodes"
    :label-key="labelKey"
    :item-key="idKey"
    :error="error"
    :transform-to-tree="false"
    :create-on-enter="createOnEnter"
    @filter="onFilter"
    @change="onChange"
    :invalid="invalid"
  />
</template>

<script>
import TreeInput from "@/components/inputs/TreeInput.vue";

export default {
  name: "TreeSelectInput",
  components: {TreeInput},
  props: {
    modelValue: String,
    label: {
      type: String,
      required: true
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    idKey: {
      type: String,
      default: 'value'
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array
    },
    error: {
      default: null
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showFilter: {
      type: Boolean,
      default: true
    },
    modelType: {
      type: String,
      default: 'object' // or 'id'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    async: {
      type: Boolean,
      default: false
    },
    asyncMethod: {
      type: String
    },
    disableBranchNodes: {
      type: Boolean,
      default: false
    },
    createOnEnter: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'change', 'filter'],
  computed: {
    value: {
      get() {
        if (this.multiple && typeof this.modelValue === 'string') {
          return [this.modelValue]
        } else {
          return this.modelValue || null
        }
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  methods: {
    onChange() {
      this.$emit('change')
    },
    onFilter(filter) {
      this.$emit('filter', filter)
    }
  }
}
</script>

<style scoped>

</style>
